export const IntervalTimes = {
    DEVICE_MQTT_RESEND_STATE: 7 * 60 * 1000, //co ile ma wysylac zapytanie o full dev state etc
    DEVICE_OUTDATED_DATA: 15 * 60 * 1000, //za jaki czas stwierdzic ze dane sa nieaktualne
    DEVICE_OUTDATED_DATA_CHECK: 5000 //co ile sprawdzac czy dane sa nieaktualne
};